import { registerStep } from "./stepsRegistry";
import type { StepDefinition } from "./types";
import { PersonalInfoStep } from "@/components/form-steps/PersonalInfoStep";
import { BasicInfoSchema } from "@/schemas/multistep/basic-info.schema";

const definition: StepDefinition = {
  id: "informacionBasica",
  title: "Informacion Basica",
  schema: BasicInfoSchema,
  Component: PersonalInfoStep,
  isApplicable: () => true,
};

registerStep(definition);
